<app-journal-list-widget
    #journalListWidget
    [autoFocusSearch]="false"
    [fillHeightList]="fillHeightList"
    [addInDialog]="true"
    [dialogEditMode]="true"
    [checkboxMode]="false"
    [autoloadItems]="false"
>
</app-journal-list-widget>
